export enum FinvoiceParserPatternType {
    REGISTRATION_NUMBER_HEADER = 'registration-number-header',
    REGISTRATION_NUMBER = 'registration-number',
}
